import { FETCH_GET } from "../../config";

export const FETCH_CATEGORY_SHOWCASES_PENDING = "FETCH_CATEGORY_SHOWCASES_PENDING";
export const FETCH_CATEGORY_SHOWCASES_FULFILLED = "FETCH_CATEGORY_SHOWCASES_FULFILLED";
export const FETCH_CATEGORY_SHOWCASES_REJECTED = "FETCH_CATEGORY_SHOWCASES_REJECTED";

export const FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_PENDING = "FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_PENDING";
export const FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_FULFILLED = "FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_FULFILLED";
export const FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_REJECTED = "FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_REJECTED";

export const fetchCategoryShowcases = () => {
  const query = `query={getActiveCategoryShowcases{id,title,categories{id,title,slug},image,order,active}}`;
  
  return async (dispatch) => {
    dispatch({ type: FETCH_CATEGORY_SHOWCASES_PENDING });
    
    try {
      const result = await FETCH_GET(query);
      
      if (result.data.errors) {
        dispatch({
          type: FETCH_CATEGORY_SHOWCASES_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_CATEGORY_SHOWCASES_FULFILLED,
          payload: result.data.data.getActiveCategoryShowcases,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CATEGORY_SHOWCASES_REJECTED,
        payload: [{ message: error.toString() }],
      });
    }
  };
};

export const fetchCategoryShowcaseWithProducts = (id) => {
  const query = `query={getCategoryShowcaseWithProducts(id:"${id}"){id,title,categories{id,title,slug},image,order,active,products{id,name,slug,image,price,sale_price,stock,categories{id,title,slug}}}}`;
  
  return async (dispatch) => {
    dispatch({ type: FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_PENDING });
    
    try {
      const result = await FETCH_GET(query);
      
      if (result.data.errors) {
        dispatch({
          type: FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_FULFILLED,
          payload: result.data.data.getCategoryShowcaseWithProducts,
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CATEGORY_SHOWCASE_WITH_PRODUCTS_REJECTED,
        payload: [{ message: error.toString() }],
      });
    }
  };
};


// WEBPACK FOOTER //
// ./src/store/actions/categoryShowcase.js